import { api, TCustomAxiosPaginationResponse, TCustomAxiosResponse } from '..';
import { MIN_CHARS_TO_DO_SEARCH } from '@/constants/numberVars';
import { apiPaths } from '@/services/api/paths';
import { SUPER_ADMIN_PAGE_SIZE } from '@/constants/numberVars';
import {
  TCreatorApplicantType,
  TCreatorApplicationDetail,
  TCreatorApplicationListItem,
  TCreatorApplicationStatus,
} from '@/types/CreatorApplication.types';

export const getCreatorApplications = async (
  page: number,
  // Free-text search (`q`) over applicant name + email.
  filterText: string,
  status: TCreatorApplicationStatus,
  applicantType?: TCreatorApplicantType,
  // Backend `sort` format: `<field>:<asc|desc>` (e.g. `submittedAt:desc`).
  sort?: string,
  pageSize: number = SUPER_ADMIN_PAGE_SIZE,
): Promise<TCustomAxiosPaginationResponse<TCreatorApplicationListItem[]>> => {
  const params: { [key: string]: string | number } = {
    limit: pageSize,
    page,
    status,
  };

  if (applicantType) {
    params.applicantType = applicantType;
  }

  if (sort) {
    params.sort = sort;
  }

  if (filterText && filterText.length >= MIN_CHARS_TO_DO_SEARCH) {
    params.q = filterText;
  }

  const { data } = await api.get<TCustomAxiosPaginationResponse<TCreatorApplicationListItem[]>>(
    apiPaths.creatorApplications.root,
    { params },
  );

  return data;
};

export const getCreatorApplicationById = async (id: string): Promise<TCreatorApplicationDetail> => {
  const { data } = await api.get(apiPaths.creatorApplications.byId(id));

  return data.data as TCreatorApplicationDetail;
};

export const approveCreatorApplication = async (
  id: string,
): Promise<TCustomAxiosResponse<TCreatorApplicationDetail>> => {
  const { data } = await api.post(apiPaths.creatorApplications.approve(id), {});

  return data;
};

export const rejectCreatorApplication = async (
  id: string,
  decisionNotes: string,
): Promise<TCustomAxiosResponse<TCreatorApplicationDetail>> => {
  const { data } = await api.post(apiPaths.creatorApplications.reject(id), { decisionNotes });

  return data;
};
